import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=98adb65e&scoped=true&"
import script from "./TasksTable.vue?vue&type=script&lang=js&"
export * from "./TasksTable.vue?vue&type=script&lang=js&"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=98adb65e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98adb65e",
  null
  
)

export default component.exports